<!--
  护林页面参数介绍：
  lon：经度
  lat：纬度
  zrqobjid:责任区id
  zrqlx:责任区类型
  from: lztandroid(林长通安卓) 、lztios（林长通iOS）、hltandroid（护林通安卓）
-->
<template>
  <div class="dhmap-wrapper hulinPage">
    <div class="infobox" v-if="infotip">
      <div class="infotip" v-if="flagPosition" style="background-color:#1989fa">未获取到位置信息！</div>
      <div class="infotip" v-if="flagZrq" style="background-color:#1989fa">暂未分配责任区！</div>
      <div class="infotip" v-if="flagInzrq" style="background-color:#1989fa">用户不在责任区，无法签到或巡林！</div>
      <div class="infotip" v-if="flagWalking" style="background-color:#58bd6b">
        <!-- <van-loading size="20" color="#fff"></van-loading> -->
        <span style="color:#fff">
          正在巡林&nbsp;
          <span style="display: inline-block;width:20px;text-align:left">{{loadingtext}}</span>
        </span>
      </div>
    </div>
    <div id="protectmap" ref="protectmap"></div>
    <van-goods-action :safe-area-inset-bottom="true">
       <van-goods-action-button
        v-if="showStart"
        :disabled="linWalk"
        color="linear-gradient(to left, #31aa48, #58bd6b)"
        text="巡林"
        @click="listTypeXjSelected = null;showXunlinType = true"
      />
      <van-goods-action-button
        v-if="showStop"
        color="linear-gradient(to left, #31aa48, #58bd6b)"
        text="结束"
        @click="stopWalk"
      />
      <van-goods-action-button
        v-if="showQd"
        :disabled="linCheck"
        color="linear-gradient(to left, #4bb0ff, #3d8af2)"
        text="签到"
        @click="listTypeQdSelected = null;qdremark='';showQiandaoType= true"
      />
    </van-goods-action>
    <van-popup
      v-model="showXunlinType"
      round
      position="bottom"
      class="XunlinPicker"
      :style="{ height: '60%'}"
    >
      <div class="xunlinMain">
        <div class="qiandaoMain">
          <van-radio-group v-model="listTypeXjSelected">
            <van-cell-group>
              <van-cell
                v-for="(item) in listTypeXj"
                :key="item.code"
                :title="item.name"
                clickable
                @click="listTypeXjSelected = item.code"
              >
                <van-radio slot="right-icon" :name="item.code" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <van-goods-action :safe-area-inset-bottom="true" class="btnBox sureQdlbox">
          <van-goods-action-button type="primary" block round @click="handleStartConfirm">开始巡林</van-goods-action-button>
        </van-goods-action>
      </div>
    </van-popup>
    <van-popup
      v-model="showQiandaoType"
      round
      class="XunlinPicker"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="xunlinMain">
        <div class="qiandaoMain">
          <van-field
            v-model="qdremark"
            rows="2"
            autosize
            label="签到说明"
            type="textarea"
            maxlength="50"
            placeholder="请输入签到说明（可不填）"
            show-word-limit
          />
          <van-radio-group v-model="listTypeQdSelected">
            <van-cell-group>
              <van-cell
                v-for="(item) in listTypeQd"
                :key="item.code"
                :title="item.name"
                clickable
                @click="listTypeQdSelected = item.code"
              >
                <van-radio slot="right-icon" :name="item.code" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <van-goods-action :safe-area-inset-bottom="true" class="btnBox sureQdlbox">
          <van-goods-action-button type="primary" block round @click="handleQd">确认签到</van-goods-action-button>
        </van-goods-action>
      </div>
    </van-popup>
    <div class="gistoolbox btnBox">
      <van-button plain type="info" round @click="locatePosition">
        <van-icon name="location-o" size="16" />
      </van-button>
      <van-button plain type="info" round @click="locateGlobel">
        <img src="../../assets/gisicon/icon_globle.png" />
      </van-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  actLocate,
  getLayerByType
} from "@/utils/MapUtils";
import { Vector as VectorLayer } from "ol/layer.js";
import VectorSource from "ol/source/Vector.js";
import { Style, Stroke, Fill, Text, Circle, Icon } from "ol/style.js";
import { locateStyleCollection } from "@/utils/MapIcons";
import { Point, LineString, Polygon } from "ol/geom";
import Feature from "ol/Feature";
import { fromLonLat, transformExtent } from "ol/proj";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
// import * as jsts from 'jsts/dist/jsts.min.js'

export default {
  name: "protector",
  components: {},
  props: {},
  data() {
    return {
      infotip: false,
      flagPosition: false,
      flagZrq: false,
      flagInzrq: false,
      flagWalking: false,
      linWalk: true,
      linCheck: true,
      showQd: false,
      showStop: false,
      showStart: true,
      showXunlinType: false,
      showQiandaoType: false,
      param: {},
      map: null,
      gisconfig: {},
      zrqVector: null,
      zrqSourceVector: null,
      zrqStyle: new Style({
        stroke: new Stroke({
          color: "#2a32fc",
          width: 5.5
        })
      }),
      gjVector: null,
      gjSourceVector: null,
      gjStyle: new Style({
        // stroke: new Stroke({
        //   color: '#000000',
        //   width: 5.5
        // })
      }),
      gjManStyle: locateStyleCollection["default"],
      currentTask: null,
      listTypeXj: [],
      listTypeXjSelected: null,
      listTypeQd: [],
      listTypeQdSelected: null,
      qdremark: "",
      lzFeature: null,
      zrqFeature: null,
      gjFeature: null,
      timer: null,
      loadingtext: "",
      clientType: ""
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    //经纬度参数必传校验
    if (!this.$route.query.lon || !this.$route.query.lat) {
      this.infotip = true;
      this.flagPosition = true;
    }
    this.param.lon = this.$route.query.lon;
    this.param.lat = this.$route.query.lat;
    //责任区参数必传校验
    if (
      !this.flagPosition &&
      (!this.$route.query.zrqobjid || !this.$route.query.zrqlx)
    ) {
      this.infotip = true;
      this.flagZrq = true;
    }
    this.param.zrqobjid = this.$route.query.zrqobjid;
    this.param.zrqlx = this.$route.query.zrqlx;
    //根据设备类型，加载功能
    if (this.$route.query.from != "hltandroid") {
      this.showQd = true;
    }
    //加载地图
    this.loadMap();
    //加载字典
    this.loadDict();
    var _this = this;
    setInterval(function() {
      if (_this.loadingtext.length == 3) {
        _this.loadingtext = "";
      }
      _this.loadingtext = _this.loadingtext + ".";
    }, 900);
  },
  methods: {
    loadMap() {
      var _this = this;
      if (_this.userinfo && _this.userinfo.appId) {
        this.$api.Mapapi.getconfig({
          appId: _this.userinfo.appId
        })
          .then(res => {
            if (res && res.code == 1) {
              _this.gisconfig = res.data;
              //设置该地图根据CQL进行过滤加载
              _this.gisconfig.queryWithCQL = true;
              //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
              _this.gisconfig.uid = _this.userinfo.uid;
              _this.gisconfig.uregion = _this.userinfo.zqCode;
              _this.gisconfig.uregionlevel = [
                null,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                5
              ][_this.gisconfig.uregion.length];
              //初始化地图
              _this.map = initMap("protectmap", _this.gisconfig, {
                showZoom: false
              });
              _this.map.gisConfig = res.data;
              //如果参数校验未通过，就不需要终止逻辑了
              if (this.flagPosition || this.flagZrq) {
                return;
              }
              addLayerToMap(_this.map, _this.gisconfig, null, [
                "tdtjd",
                "tdtzj",
                "geo_sheng",
                "geo_shi",
                "geo_xian",
                "geo_xiang",
                "geo_cun"
              ]);
              //删掉谷歌底图（优化性能）、因为巡林采用天地图影像
              _this.map.removeLayer(getLayerByType(_this.map, "google"));
              getLayerByType(_this.map, "tdt").setVisible(true);
              _this.initVectorLayer();
              //绘制责任区边界和用户自己的位置
              _this.drawZrqAndUserPosition();
              //注册轨迹线动画效果
              _this.addLineAnimate();
            } else {
              _this.$toast(res.msg);
            }
          })
          .catch(err => {
            _this.$toast("地图加载异常!");
          });
      }
    },
    loadDict() {
      var _this = this;
      this.$api.Mapapi.getDict({
        parentCode: "PROTECT_PATROL_TYPE"
      }).then(res => {
        if (res && res.code == 1) {
          _this.listTypeXj = res.data;
        } else {
          _this.$toast(res.msg);
        }
      });
      this.$api.Mapapi.getDict({
        parentCode: "PROTECT_SIGN_TYPE"
      }).then(res => {
        if (res && res.code == 1) {
          _this.listTypeQd = res.data;
        } else {
          _this.$toast(res.msg);
        }
      });
    },
    drawZrqAndUserPosition() {
      //检查是否位于责任区
      var _this = this;
      if (_this.param.zrqlx && _this.param.zrqobjid) {
        actLocate(
          _this.map,
          _this.param.zrqlx,
          _this.param.zrqobjid,
          _this.zrqVector,
          function() {
            _this.zrqFeature = _this.zrqSourceVector.getFeatures()[0];
            //定位人员（根据lon和lat创建一个feature并添加到轨迹图层）
            if (_this.param.lon && _this.param.lat) {
              _this.lzFeature = _this.createFeatureFromLonLat(
                _this.param.lon,
                _this.param.lat
              );
              if (_this.lzFeature) {
                _this.lzFeature.is_user = true;
                _this.gjSourceVector.addFeature(_this.lzFeature);
              }
            }
            //绘制完成后，请求是否之前存在未结束的巡林
            _this.queryUnFinishedXunlin();
          }
        );
      }
    },
    queryUnFinishedXunlin() {
      var _this = this;
      //如果存在界面还原至上次巡林状态，如果不存在则启用各功能按钮
      this.$api.Mapapi.getUnfinishedProtect({})
        .then(res => {
          if (res && res.code == 1) {
            if (res.data && res.data.id) {
              _this.currentTask = res.data;
              this.beginWalk();
            } else {
              //如果暂无巡林的话，还需进行用户是否位于责任区的检测
              if (
                !_this.lzFeature ||
                !_this.zrqFeature ||
                !_this.zrqFeature
                  .getGeometry()
                  .intersectsCoordinate(
                    _this.lzFeature.getGeometry().getFirstCoordinate()
                  )
              ) {
                _this.infotip = true;
                _this.flagInzrq = true;
                return;
              }
              //将巡林、签到按钮开启
              this.linWalk = false;
              this.linCheck = false;
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("获取未完成的巡林失败!");
        });
    },
    beginWalk() {
      if (this.currentTask && this.currentTask.id) {
        this.flagPosition = this.flagZrq = this.flagInzrq = this.showStart = false;
        this.infotip = this.linCheck = this.linWalk = this.showStop = true;
        this.flagWalking = true;
        if (!this.timer) {
          //在地图上定时刷新巡林轨迹
          let _this = this;
          actLocate(
            _this.map,
            "lz_protect_forest",
            _this.currentTask.objid,
            _this.gjVector,
            function() {
              _this.gjFeature = _this.gjSourceVector.getFeatures()[0];
            },
            true
          );

          this.timer = setInterval(function() {
            actLocate(
              _this.map,
              "lz_protect_forest",
              _this.currentTask.objid,
              _this.gjVector,
              function() {
                _this.gjFeature = _this.gjSourceVector.getFeatures()[0];
              },
              true
            );
          }, 10000);
        }
      }
    },
    stopWalk() {
      var _this = this;
      this.$dialog
        .confirm({
          message: "确认要结束本次巡林吗？"
        })
        .then(() => {
          this.$api.Mapapi.protectStop(_this.currentTask.id)
            .then(res => {
              _this.infotip = _this.linCheck = _this.linWalk = _this.showStop = _this.flagWalking = false;
              _this.showStart = true;
              _this.currentTask = _this.gjFeature = null;
              if (_this.timer) {
                clearInterval(_this.timer);
              }
              _this.timer = null;
              if (res && res.code == 1) {
                this.$toast.success({
                  message: res.msg, //"完成巡林\n里程"+res.data.distance+"公里",
                  duration: 5000
                });
              } else {
                _this.$toast({
                  message: res.msg, //"本次巡林无效\n"+res.msg,
                  duration: 5000
                });
              }
            })
            .catch(err => {
              _this.$toast("结束巡林异常!");
            });
        });
    },
    handleStartConfirm() {
      if (!this.listTypeXjSelected) {
        this.$toast("请先选择巡林类型");
        return;
      }
      var _this = this;
      this.$api.Mapapi.protectStart({
        gridObjid: _this.param.zrqobjid,
        gridLevel:
          [
            "geo_grid_sheng",
            "geo_grid_shi",
            "geo_grid_xian",
            "geo_grid_xiang",
            "geo_grid_cun"
          ].indexOf(_this.param.zrqlx) + 1,
        type: _this.listTypeXjSelected
      })
        .then(res => {
          if (res && res.code == 1) {
            this.showXunlinType = false;
            this.currentTask = res.data;
            this.beginWalk();
            if (_this.clientType == "android") {
              window.android.getInfo(110, this.currentTask.id);
            } else {
              window.webkit.messageHandlers.updatePosition.postMessage(
                this.currentTask.id
              );
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("开始巡林异常!");
        });
    },
    handleQd() {
      if (!this.listTypeQdSelected) {
        this.$toast("请先选择签到类型");
        return;
      }
      var _this = this;
      this.$api.Mapapi.protectSign({
        gridObjid: _this.param.zrqobjid,
        gridLevel:
          [
            "geo_grid_sheng",
            "geo_grid_shi",
            "geo_grid_xian",
            "geo_grid_xiang",
            "geo_grid_cun"
          ].indexOf(_this.param.zrqlx) + 1,
        type: _this.listTypeQdSelected,
        point: {
          x: _this.param.lon,
          y: _this.param.lat
        },
        remarks: _this.qdremark
      })
        .then(res => {
          if (res && res.code == 1) {
            this.showQiandaoType = false;
            _this.$toast.success({
              message: "签到成功！"
            });
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("开始巡林异常!");
        });
    },
    initVectorLayer() {
      //初始化一个责任区矢量图层，用于绘制责任区
      var _this = this;
      this.zrqSourceVector = new VectorSource();
      this.zrqVector = new VectorLayer({
        source: this.zrqSourceVector,
        style: function(feature) {
          return _this.zrqStyle;
        }
      });
      this.map.addLayer(this.zrqVector);
      //初始化一个轨迹矢量图层，用于绘制轨迹或人员位置
      this.gjSourceVector = new VectorSource();
      this.gjVector = new VectorLayer({
        source: this.gjSourceVector,
        style: function(feature) {
          if (feature.getGeometry().constructor === Point) {
            return _this.gjManStyle;
          } else if (feature.getGeometry().constructor === LineString) {
            return _this.gjStyle;
          }
        }
      });
      this.map.addLayer(this.gjVector);
    },
    createFeatureFromLonLat(lon, lat) {
      return new Feature({
        geometry: new Point(fromLonLat([lon, lat], "EPSG:4326"))
      });
    },
    addLineAnimate() {
      var buttomPathStyle = new Style({
        stroke: new Stroke({
          color: [4, 110, 74],
          width: 18
        })
      });
      var upperPathStyle = new Style({
        stroke: new Stroke({
          color: [0, 186, 107],
          width: 12
        })
      });
      var runnerStyle = new Style({
        image: new Circle({
          radius: 5,
          fill: new Fill({
            color: "rgba(255, 255, 254, 1)"
          })
        })
      });
      var offset = 0.01;
      var _this = this;
      var baselayer = this.map.getLayers().getArray()[0];
      baselayer.on("postcompose", evt => {
        var vct = evt.vectorContext;
        if (_this.gjFeature) {
          vct.drawFeature(_this.gjFeature, buttomPathStyle);
          vct.drawFeature(_this.gjFeature, upperPathStyle);
          let numArr = Math.ceil(
            _this.gjFeature.getGeometry().getLength() /
              _this.map.getView().getResolution() /
              80
          );
          var points = [];
          for (var i = 0; i <= numArr; i++) {
            let fracPos = i / numArr + offset;
            if (fracPos > 1) fracPos -= 1;
            let pf = new Feature(
              new Point(_this.gjFeature.getGeometry().getCoordinateAt(fracPos))
            );
            points.push(pf);
          }
          //确定方向并绘制
          _this.gjFeature.getGeometry().forEachSegment((start, end) => {
            points.forEach(item => {
              let line = new LineString([start, end]);
              let coord = item.getGeometry().getFirstCoordinate();
              let cPoint = line.getClosestPoint(coord);
              if (
                Math.abs(cPoint[0] - coord[0]) < 1 &&
                Math.abs(cPoint[1] - coord[1]) < 1
              ) {
                vct.setStyle(runnerStyle);
                vct.drawGeometry(item.getGeometry());
              }
            });
          });
          offset = offset + 0.0015;
          //复位
          if (offset >= 1) offset = 0.001;
          _this.map.render();
        }
      });
    },
    locatePosition() {
      var _this = this;
      if (_this.param.lon && _this.param.lat) {
        var f = _this.createFeatureFromLonLat(_this.param.lon, _this.param.lat);
        _this.gjSourceVector.addFeature(f);
        _this.map.getView().animate({
          center: [_this.param.lon, _this.param.lat],
          duration: 500
        });
      }
    },
    locateGlobel() {
      //检查是否位于责任区
      var _this = this;
      if (_this.param.zrqlx && _this.param.zrqobjid) {
        actLocate(
          _this.map,
          _this.param.zrqlx,
          _this.param.zrqobjid,
          _this.zrqVector
        );
      }
    }
  },
  computed: {
    ...mapState(["userinfo"])
  },
  watch: {
    userinfo() {
      this.loadMap();
    }
  }
};
</script>

<style scoped>
.dhmap-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#protectmap {
  width: 100%;
  height: 100%;
}
.infobox {
  width: 100%;
  height: 30px;
}
.infotip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 5px;
  color: #fff;
  font-size: 13px;
}
</style>
<style>
.van-goods-action {
  background-color: none;
}
.van-goods-action-icon {
  background: none;
}
.van-goods-action-icon:active {
  background: none;
}
.gistoolbox {
  position: absolute;
  width: 50px;
  left: 10px;
  bottom: 70px;
  /* z-index: 99999999; */
}
.van-button--normal {
  padding: 0;
  margin-bottom: 10px;
  width: 32px;
  height: 32px;
  line-height: 37px;
}
.sureQdlbox  .van-goods-action-button--last{
  border-radius:26.64rem;
}
</style>
<style lang="less">
.dhmap-wrapper.hulinPage {
  .XunlinPicker {
    // position: relative;
    .xunlinMain {
      // padding: 15px 15px 65px 15px;
      position: relative;
      height: 100%;
      .qiandaoMain {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        padding: 15px 15px 65px 15px;
      }
      .btnBox {
        position: absolute !important;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>